import styled from "styled-components";

import { typography } from "globalConstants";
import { Atoms } from "Types/Components";

export type PropsType = Atoms.Text;
const Wrap = styled.h2<any>`
   overflow-wrap: break-word;
   word-break: keep-all;
   ${({ css }) => css}
   ${({ typography }) => typography}
`;

export default function Text(props: PropsType) {
   return (
      <Wrap {...props} typography={typography.other[props.t]}>
         {props.children}
      </Wrap>
   );
}
